import ApiBase from '../api-base'
import {ACTIVE_BASE_REST} from '../constants'

export default class CmsArea extends ApiBase {
    constructor(store) {
        const path = ACTIVE_BASE_REST + '/cms/area'
        super(store, path)
    }
}